<template>
  <div class="main-container">
    <slot name="bread" :detail="detail"></slot>
    <div class="main-content">
      <div class="title">{{ detail.title }}</div>
      <div class="statistics">
        <div class="item">
          <div class="item-rate">
            <el-progress
              type="circle"
              :percentage="parseFloat(detail.accuracy)"
              color="#44D67A"
              :show-text="false"
              :stroke-width="10"
              :width="162"
            ></el-progress>
            <div class="rate-wrap">
              <div class="num-wrap">
                <span class="num">{{ detail.accuracy_int }}</span>
                <span class="percent">
                  {{
                    detail.accuracy_decimal
                      ? "." + detail.accuracy_decimal
                      : ""
                  }}%
                </span>
              </div>
              <div class="label">
                <span>正确率</span>
                <span class="help">
                  <span class="text">正确率=答对的题目总数/客观题题目总数</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="item" v-if="packageCourse.length">
          <div class="item-watch">
            <div class="watch-content">
              <p>查看视频解析</p>
              <p>讲解更细致，印象更深刻</p>
            </div>
            <div class="btns">
              <a class="btn" @click="lookCourse">立即查看</a>
            </div>
          </div>
        </div>
        <div
          class="item"
          :class="{ 'item-package': isPackage, 'item-3': packageCourse.length }"
        >
          <div class="item-time">
            <div class="submit">
              <span class="label">交卷时间</span>
              <span class="text">{{ detail.submit_time | tsFormatLong }}</span>
            </div>
            <div class="answer">
              <span class="label">作答时长</span>
              <span class="text">{{ detail.answer_time_str }}</span>
            </div>
            <div class="score" v-if="isPackage">
              <span class="label">客观题得分</span>
              <span class="text">{{ detail.user_score }}分</span>
            </div>
            <div class="btns">
              <a class="btn" @click="goAnalysis(2)">错题解析</a>
              <a class="btn" @click="goAnalysis(1)">全部解析</a>
              <a class="btn" @click="goRepeat">重新练习</a>
            </div>
          </div>
        </div>
      </div>
      <div class="number-container">
        <div class="header">
          <div class="title">答题卡</div>
          <div class="legend-wrap">
            <span class="legend status-1"></span>
            <span class="text">正确({{ detail.right_num }})</span>
            <span class="legend status-2"></span>
            <span class="text">错误({{ detail.wrong_num }})</span>
            <span class="legend status-3"></span>
            <span class="text">
              未作答({{
                detail.total_num -
                detail.right_num -
                detail.wrong_num -
                detail.no_answer_num
              }})
            </span>
            <span class="legend status-4"></span>
            <span class="text">简答题作答({{ detail.no_answer_num }})</span>
          </div>
        </div>
        <div class="legends" :class="{ 'legends-package': isPackage }">
          <template v-for="(item, index) in detail.answer_sheet">
            <template v-if="item.child">
              <div class="section" :key="'section-' + item.id">
                {{ item.name }}
              </div>
              <div :key="'nums-' + item.id">
                <span
                  v-for="ques in item.child"
                  :key="ques.sort"
                  class="legend"
                  :class="'status-' + ques.status"
                >
                  {{ ques.sort }}
                </span>
              </div>
            </template>
            <span
              v-else
              :key="index"
              class="legend"
              :class="'status-' + item.status"
            >
              {{ index + 1 }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <LimitModal ref="limitModal" />
    <el-dialog
      :modal-append-to-body="false"
      class="pop-dialog"
      title="选择课程"
      :visible="showCourse"
      :before-close="onClose"
      width="30%"
    >
      <ul class="course-content">
        <li
          @click="onCourse(item)"
          v-for="item in packageCourse"
          :key="item.course_id"
        >
          <p>
            <span class="course-title">{{ item.title }}</span>
            <span class="is_buy" v-if="item.is_buy">已购</span>
          </p>
          <i class="el-icon-arrow-right icon-right"></i>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ExamReport",
  props: {
    isPackage: {
      type: Boolean,
      default: false,
    },
    reportType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      questionType: "",
      detail: { accuracy: 0 },
      packageCourse: [],
      showCourse: false,
    };
  },
  async created() {
    this.getCourseData();
    let data = await this.$http.get(
      "/api/app/practice/detail/" + this.$route.query.id,
    );
    data.accuracy = data.accuracy.toString().replace("%", "");
    data.accuracy_int = data.accuracy.split(".")[0];
    data.accuracy_decimal = data.accuracy.split(".")[1] || "";
    const newData = this.getTime(data.answer_time);
    data.answer_time_str = `${newData.hours}:${newData.min}:${newData.ss}`;
    // data.answer_time_str =
    //   parseInt(data.answer_time / 3600) +
    //   ":" +
    //   parseInt(data.answer_time / 60) +
    //   ":" +
    //   (data.answer_time % 60);
    this.detail = data;
    this.$emit("created", data);
  },
  methods: {
    getTime(data) {
      const hours =
        parseInt(data / 3600) < 10
          ? `0${parseInt(data / 3600)}`
          : parseInt(data / 3600);
      data = data - hours * 3600;
      const min =
        parseInt(data / 60) < 10
          ? `0${parseInt(data / 60)}`
          : parseInt(data / 60);
      data = data - min * 60;
      const ss =
        parseInt(data % 60) < 10
          ? `0${parseInt(data % 60)}`
          : parseInt(data % 60);
      return {
        hours,
        min,
        ss,
      };
    },
    async getCourseData() {
      if (this.reportType == "package") {
        this.packageCourse = await this.$http.get(
          `/api/app/practice/recommend/${this.$route.query.id}`,
        );
      }
    },
    //重新练习，根据页面类型判断答题次数是否用完
    async goRepeat() {
      if (this.reportType && this.reportType == "random") {
        //判断随机练习免费答题次数是否用完
        await this.$refs.limitModal.checkAnswer(1, "随机练习");
      } else if (this.reportType && this.reportType == "special") {
        await this.$refs.limitModal.checkAnswer(3, "专项练习");
      } else if (this.reportType && this.reportType == "package") {
        const is_can_do = this.detail.is_can_do || "";
        if (is_can_do && is_can_do == 2) {
          //会员过期
          this.visible = true;
          this.questionType = "套卷练习";
          return;
        } else if (is_can_do && is_can_do == 3) {
          //判断有没有权限进入套卷练习
          this.$message.warning("您没有权限进入");
          return;
        }
      }
      this.$emit("goRepeat");
    },
    goAnalysis(type) {
      if (type == 2 && this.detail.wrong_num == 0) {
        this.$info("没有错题");
        return;
      }
      this.$emit("goAnalysis", type);
    },
    lookCourse() {
      if (this.packageCourse.length > 1) {
        this.showCourse = true;
      } else {
        this.onCourse(this.packageCourse[0]);
      }
    },
    onCourse(data) {
      if (data.course_type == 4) {
        this.$livePlay(data.course_id, data.course_type, {
          id: 0,
          title: data.title,
        });
        return;
      }
      if (data.is_buy) {
        this.$router.push({
          name: "MemberStudy",
          query: { type: data.course_type, id: data.course_id },
        });
      } else {
        this.$router.push({
          name: "CourseShow",
          params: { id: data.course_id },
        });
      }
    },
    onClose() {
      this.showCourse = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  padding: 29px 42px 0 29px;
  overflow: hidden;
  margin-bottom: 30px;
}
.pop-dialog {
  /deep/ .el-dialog__header {
    padding: 20px 24px;
    .el-dialog__title {
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0 24px 24px 24px;
  }
}

.course-content {
  li {
    height: 40px;
    display: flex;
    align-items: center;
    p {
      flex: 1;
    }
    .course-title {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      color: #333333;
      line-height: 22px;
    }
    .is_buy {
      display: inline-block;
      width: 36px;
      height: 21px;
      border: 1px solid #ffa000;
      border-radius: 4px;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      color: #ffa000;
      text-align: center;
      line-height: 21px;
      margin-left: 8px;
    }
  }
}
.title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(52, 52, 52, 1);
  line-height: 1;
  margin-bottom: 26px;
}
.statistics {
  background: white;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 5px;
  height: 229px;
  display: flex;
  align-items: center;
  margin-bottom: 32px;

  .item {
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    position: relative;
    flex: 2;
    &::after {
      content: "";
      position: absolute;
      width: 1px;
      height: 130px;
      background: #e3e3e3;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &:last-of-type {
      &::after {
        display: none;
      }
    }
  }

  .item-3 {
    flex: 3;
  }

  .item-rate {
    .rate-wrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
    .num-wrap {
      margin-bottom: 16px;
      display: flex;
      align-items: flex-end;
    }
    .num {
      font-size: 46px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 35px;
    }
    .percent {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 16px;
    }
    .label {
      font-size: 16px;
      color: rgba(52, 52, 52, 1);
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .help {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url("~@/assets/images/exam/help@2x.png");
      background-size: 100% 100%;
      position: relative;
      margin-left: 4px;
      cursor: pointer;

      &:hover {
        .text {
          display: block;
        }
      }

      .text {
        position: absolute;
        top: 22px;
        left: -127px;
        white-space: nowrap;
        height: 30px;
        padding: 0 10px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 3px;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        cursor: default;
        display: none;
      }
    }
  }

  .item-time {
    flex-direction: column;
    .submit,
    .answer,
    .score {
      font-size: 14px;
      line-height: 1;
      margin-bottom: 24px;
    }

    .score {
      .label {
        margin-right: 21px;
      }
    }

    .label {
      color: #999999;
      margin-right: 34px;
    }

    .text {
      color: #333333;
    }

    &.item-package {
      .submit {
        margin-bottom: 18px;
      }

      .answer {
        margin-bottom: 18px;
      }

      .score {
        margin-bottom: 27px;
      }
    }
  }

  .item-watch {
    .watch-content {
      background: url("~@stu/images/exam/package/icon-exam-course.png")
        no-repeat left 10px;
      background-size: 54px 54px;
      padding-left: 70px;
      padding-top: 10px;
      padding-bottom: 50px;
      p {
        &:nth-child(1) {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: #333333;
          line-height: 20px;
          padding-top: 3px;
        }
        &:nth-child(2) {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          color: #999999;
          line-height: 20px;
          margin-top: 7px;
        }
      }
    }
  }

  .btn {
    display: inline-block;
    width: 109px;
    height: 36px;
    font-size: 14px;
    color: #343434;
    border-radius: 5px;
    line-height: 34px;
    background: rgba(252, 86, 36, 0);
    border: 1px solid rgba(217, 217, 217, 1);
    text-align: center;
    margin-right: 10px;
    cursor: pointer;

    &:hover {
      border-color: $primary-color;
      color: $primary-color;
    }

    &:first-child {
      background: $primary-color;
      border-color: $primary-color;
      color: white;
      &:hover {
        background: $primary-color-hover;
        border-color: $primary-color-hover;
      }
    }
  }
}
.number-container {
  border: 1px solid rgba(234, 237, 237, 1);
  border-radius: 6px;
  margin-bottom: 32px;
  .header {
    background-color: #eaeded;
    height: 40px;
    box-sizing: border-box;
    padding: 0 28px 0 19px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 1;
      margin-bottom: 0;
    }
    .legend-wrap {
      display: flex;
      align-items: center;
      .legend {
        margin-right: 5px;
      }
      .text {
        margin-right: 20px;
        font-size: 14px;
        color: #343434;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .legend {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    box-sizing: border-box;
    &.status-1 {
      background-color: #14cc5a;
      color: white;
    }
    &.status-2 {
      background-color: #ff2e28;
      color: white;
    }
    &.status-3 {
      background-color: #ffffff;
      border: 1px solid rgba(192, 192, 192, 1);
      color: #343434;
    }
    //简答题作答
    &.status-4 {
      background-color: #ef811e;
      color: #fff;
    }
  }
  .legends {
    padding: 28px 0 0 21px;
    background-color: white;
    .legend {
      margin-bottom: 32px;
      margin-right: 16px;
      width: 36px;
      height: 36px;
      border-radius: 3px;
      text-align: center;
      line-height: 34px;
    }
    .section {
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 1;
      margin: 6px 0 15px 0;
    }
  }
  .legends-package {
    padding: 13px 0 13px 21px;
    .legend {
      margin-bottom: 16px;
    }
  }
}
</style>
